import { api } from './client';
import { User, AuthTokens } from './types';

export const authApi = {
  login: (email: string, password: string) =>
    api.post<AuthTokens>('/api/v1/auth/login', { email, password }),

  // city/country are optional and feed the public "cities we're used in" count.
  register: (data: {
    email: string;
    password: string;
    full_name?: string;
    city?: string;
    country?: string;
  }) => api.post<{ message: string }>('/api/v1/auth/register', data),

  me: () => api.get<User>('/api/v1/auth/me'),

  refresh: (refresh_token: string) =>
    api.post<AuthTokens>('/api/v1/auth/refresh', { refresh_token }),

  verifyEmail: (token: string) =>
    api.post<{ message: string }>('/api/v1/auth/verify-email', { token }),

  // The endpoint is request-password-reset; /auth/forgot-password 404s, so the
  // "forgot your password" form never sent a single email.
  forgotPassword: (email: string) =>
    api.post<{ message: string }>('/api/v1/auth/request-password-reset', { email }),

  resetPassword: (token: string, new_password: string) =>
    api.post<{ message: string }>('/api/v1/auth/reset-password', { token, new_password }),

  // `email` is deliberately absent: changing the login identifier here was an
  // account-takeover vector and the endpoint rejects it. Use changeEmail below.
  updateProfile: (data: { full_name?: string; avatar_url?: string }) =>
    api.put<User>('/api/v1/auth/profile', data),

  // ── Change of login email — change-on-confirm ───────────────────────────────
  // requestEmailChange only stores a pending address and sends two mails; the
  // login does not move until confirmEmailChange runs the token from the new
  // mailbox. cancelEmailChange uses the different token sent to the old address.
  requestEmailChange: (data: { new_email: string; current_password: string }) =>
    api.post<{ message: string }>('/api/v1/auth/change-email', data),

  getPendingEmailChange: () =>
    api.get<{ pending_email: string | null; expires_at: string | null }>(
      '/api/v1/auth/change-email',
    ),

  confirmEmailChange: (token: string) =>
    api.post<{ message: string }>('/api/v1/auth/change-email/confirm', { token }),

  cancelEmailChange: (token: string) =>
    api.post<{ message: string }>('/api/v1/auth/change-email/cancel', { token }),

  // PUT, not POST — as POST it answered 405 and no password was ever changed
  // from the settings page.
  changePassword: (current_password: string, new_password: string) =>
    api.put<{ message: string }>('/api/v1/auth/change-password', { current_password, new_password }),
};
